import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 11.99H2V21.98H11V11.99H4ZM9 19.96H4V14.01H9V19.96ZM13 12.02H22V14.04H13V12.02ZM13 15.97H22V17.99H13V15.97ZM13 19.98H22V22H13V19.98ZM20 2H2V9.99H22V2H20ZM20 7.97H4V4.02H20V7.97Z" fill={ fill || 'currentColor' } />
    </svg>
);
